module.exports = __webpack_public_path__ + "static/media/drum1.10d86d64.ogg";